import PropArray from "../core/type/propArray";
import useMap from "../core/utils/useMap";
import { transformObjectToFlat } from "../utils/zone.utils";

/**
 * 
 * @param {string} propKey 
 * @param {*} value 
 * @returns 
 */
const doTransform = (transformCallBacks, propKey, value) => {
    if (transformCallBacks.has(propKey)) {
        return transformCallBacks.get(propKey).call(null, value);
    }
    return value;
}


/**
 * @description Using to display a custom modified value
 * @returns {import("../t.d").ZoneMiddleWare}
 */
const transform = () => {
    const caching = useMap();
    const transformCallBacks = useMap();

    /**@type {import("../t.d").ZoneMiddleWare}  */
    const middleware = {
        injectTo: 'ui',
        injectProps: () => {
            return Array.from(transformCallBacks.keys())
        },
        provider: {
            getter: (propKey, value) => {
                // console.log("useMakeup", value, doTransform(propCombined, value))
                return doTransform(transformCallBacks, propKey, value);
            },
            setter: (propKey, nextValue) => {
                return nextValue
            }
        },
        action: {
            useZoneTransform: (propKey, cb) => {
                if (typeof propKey === 'object') {
                    const flatObject = transformObjectToFlat(propKey);
                    for (let k in flatObject) {
                        const cb = flatObject[k]
                        if (typeof cb !== 'function') {
                            console.error(`[useZoneTransform] The value of ${k} must be a function`);
                            continue;
                        }
                        transformCallBacks.set(k, cb)
                    }
                    return () => {
                        for (let k in flatObject) {
                            transformCallBacks.delete(k);
                        }
                    }
                } else if (typeof cb !== 'function') {
                    throw new Error('2nd arg must be a function');
                }
                transformCallBacks.set(propKey, cb)
                return () => {
                    transformCallBacks.delete(propKey)
                }
            }
        }
    }
    return middleware;
};

export default transform;